// assets/sc-nlink-fetcher.js
// 画像とタイトルのみ取得するシンプル版

class ScNlinkFetcher {
  constructor() {
    this.cache = new Map();
    this.shopDomain = window.location.hostname;
  }

  async init() {
    // ページ読み込み後にsc-nlinkカードを強化
    const cards = document.querySelectorAll('.sc-nlink-card[data-fetch="true"]');
    
    for (const card of cards) {
      await this.enhanceCard(card);
    }
  }

  async enhanceCard(card) {
    const url = card.dataset.url;
    if (!url) return;

    try {
      console.log('sc-nlink 画像・タイトル取得開始:', url);
      
      // メタデータを取得
      const metadata = await this.fetchMetadata(url);
      
      if (metadata.success) {
        this.updateCard(card, metadata);
        console.log('sc-nlink 取得成功:', { title: metadata.title, hasImage: !!metadata.image });
      } else {
        console.warn('sc-nlink 取得失敗');
      }
    } catch (error) {
      console.warn('sc-nlink エラー:', error);
    }
  }

  async fetchMetadata(url) {
    // キャッシュチェック
    if (this.cache.has(url)) {
      return this.cache.get(url);
    }

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const html = await response.text();
      const metadata = this.parseHTML(html, url);
      
      // キャッシュに保存
      this.cache.set(url, metadata);
      
      return metadata;

    } catch (error) {
      console.warn('fetchエラー:', error);
      return { 
        success: false,
        title: this.extractTitleFromUrl(url),
        image: ''
      };
    }
  }

  parseHTML(html, url) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    // タイトル取得（優先順位順）
    const title = this.getContent(doc, [
      'meta[property="og:title"]',
      'meta[name="twitter:title"]',
      'title',
      'h1.article__title',
      'h1.article-title',
      '.article-header h1',
      '.page-header h1',
      'h1'
    ]);

    // 画像取得
    const image = this.getImageUrl(doc, [
      'meta[property="og:image"]',
      'meta[name="twitter:image"]',
      '.article__featured-image img',
      '.article-featured-image img',
      '.hero-image img',
      '.page-image img',
      'img[alt*="featured"]',
      'img[alt*="thumbnail"]'
    ]);

    const result = {
      title: title.trim() || this.extractTitleFromUrl(url),
      image: image,
      success: true
    };

    console.log('解析結果:', result);
    return result;
  }

  getContent(doc, selectors) {
    for (const selector of selectors) {
      const element = doc.querySelector(selector);
      if (element) {
        if (selector.includes('meta')) {
          const content = element.getAttribute('content');
          if (content && content.trim()) return content;
        } else {
          const text = element.textContent;
          if (text && text.trim()) return text;
        }
      }
    }
    return '';
  }

  getImageUrl(doc, selectors) {
    for (const selector of selectors) {
      const element = doc.querySelector(selector);
      if (element) {
        if (selector.includes('meta')) {
          const content = element.getAttribute('content');
          if (content) return this.makeAbsoluteUrl(content);
        } else {
          const src = element.getAttribute('src') || 
                     element.getAttribute('data-src') || 
                     element.getAttribute('data-lazy');
          if (src) return this.makeAbsoluteUrl(src);
        }
      }
    }
    return '';
  }

  makeAbsoluteUrl(url) {
    if (!url) return '';
    if (url.startsWith('http')) return url;
    if (url.startsWith('//')) return `https:${url}`;
    if (url.startsWith('/')) return `https://${this.shopDomain}${url}`;
    return url;
  }

  extractTitleFromUrl(url) {
    try {
      const urlObj = new URL(url);
      const pathSegments = urlObj.pathname.split('/').filter(segment => segment);
      const lastSegment = pathSegments[pathSegments.length - 1];
      
      if (lastSegment) {
        return decodeURIComponent(lastSegment)
          .replace(/[-_]/g, ' ')
          .replace(/\b\w/g, l => l.toUpperCase());
      }
      
      return urlObj.hostname;
    } catch {
      return 'リンク';
    }
  }

  updateCard(card, metadata) {
    // タイトル更新
    const titleElement = card.querySelector('.sc-nlink-title');
    if (titleElement && metadata.title) {
      titleElement.textContent = metadata.title;
    }

    // 画像更新
    const imageContainer = card.querySelector('.sc-nlink-image');
    if (metadata.image && imageContainer.querySelector('.placeholder-icon')) {
      // img要素を作成
      const img = document.createElement('img');
      img.src = metadata.image;
      img.alt = metadata.title || 'Article image';
      img.loading = 'lazy';
      
      // エラーハンドリング
      img.onerror = function() {
        this.parentNode.innerHTML = '<div class="placeholder-icon">📄</div>';
        this.parentNode.classList.add('sc-nlink-placeholder-image');
      };
      
      // 既存の内容をクリアして新しい画像を追加
      imageContainer.innerHTML = '';
      imageContainer.appendChild(img);
      imageContainer.classList.remove('sc-nlink-placeholder-image');
    }

    // 成功クラス追加
    card.classList.add('sc-nlink-enhanced');
  }
}

// 初期化
document.addEventListener('DOMContentLoaded', () => {
  const fetcher = new ScNlinkFetcher();
  
  // ページ読み込み完了後に実行
  setTimeout(() => {
    fetcher.init();
  }, 1000);
});

// 動的に追加されたsc-nlinkカードにも対応
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1 && node.matches('.sc-nlink-card[data-fetch="true"]')) {
        const fetcher = new ScNlinkFetcher();
        setTimeout(() => {
          fetcher.enhanceCard(node);
        }, 500);
      }
    });
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});